import type { JSX } from 'react'

import type { FeatureKey } from '@type/featureKeys'

export enum LinkGroupType {
  payable = 'payable',
  receivable = 'receivable',
}

/**
 * Paywall state of a resolved entry, as /my-account reported it. A type
 * alias, not an interface: LinkGroupOption feeds react-select's Option,
 * whose index signature only object-literal types satisfy implicitly.
 */
export type LockState = {
  /** The viewer's plan lacks this feature: render locked, link to the paywall. */
  locked: boolean
  paywallPath?: string
}

/** A grouped-nav entry as declared: the feature it belongs to, and where it goes. */
export type LinkGroupOptionSpec = {
  label: string
  value: string
  feature: FeatureKey
}

/** A grouped-nav entry as resolved for one viewer (see resolveGroupOptions). */
export type LinkGroupOption = LinkGroupOptionSpec & LockState

export type LinkGroupData = {
  /** Declared entries; resolve for a viewer with `resolveGroupOptions`. */
  options: LinkGroupOptionSpec[]
  isActive(path: string): boolean
  type: LinkGroupType
}

export type SingleLinkObject = LockState & {
  to: string
  label: string | JSX.Element
  isActive: (path: string) => boolean
  feature: FeatureKey
}
